import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function EmailVerificationRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.EmailVerification', {
		url: '/admin/email_verifications',
		controllerAs: 'vm',
		permission: ['all'],
		controller: EmailVerificationCtrl,
		templateUrl: '/ng/hub/Email/Verification/EmailVerificationCtrl.html?' + window.BUILD,
		resolve: {
			style: () => AssetManager.css('/ng/hub/Email/Verification/EmailVerificationCtrl.css'),
			$title: () => 'Email Verifications',
		},
	});
}

export class EmailVerificationCtrl {
	constructor(Api, $filter, modal, $timeout) {
		'ngInject';
		this.Api = Api;
		this.$filter = $filter;
		this.modal = modal;
		this.$timeout = $timeout;
		this.filters = { provider_status: '', sender: '' };
		this.columns = [
			{ field: 'sender', label: 'Email Address', sortable: true },
			{ field: 'provider', label: 'Provider', sortable: true },
			{ field: 'created_at', label: 'Verification Email Sent', sortable: true },
			{ field: 'created_by', label: 'Verification Email Sent by', sortable: false },
			{ field: 'provider_status', label: 'Status', sortable: true },
			{ field: 'provider_approved_at', label: 'Verification Date', sortable: true },
		];
		// TODO: only show `resend` action on rows that have status `failed`. Is that possible?
		this.actions = [{ label: 'Resend', icon: null, callback: this.resendVerificationEmail.bind(this) }];
		//Pending|Success|Failed|TemporaryFailure|NotStarted
		this.providerStatuses = [
			{ name: 'Filter by verification status...', value: '' },
			{ name: 'Pending', value: 'pending' },
			{ name: 'Success', value: 'success' },
			{ name: 'Failed', value: 'failed' },
			{ name: 'sharprAttemptFailed', value: 'sharprAttemptFailed' },
		];
		this.transformRecords = this.transformRecords.bind(this);
		this.processing = false;
	}

	transformRecords(response) {
		var dateFormat = this.$filter('shDate');

		response.data = response.data.map(record => {
			record.created_at = dateFormat(record.created_at, 'long');
			record.provider_approved_at = dateFormat(record.provider_approved_at, 'long');

			return record;
		});

		return response;
	}

	async addNew() {
		const email_addresses = await this.modal.prompt({
			text: 'Email Address(es) (if multiple, separate with commas):',
		});
		if (!email_addresses) {
			return;
		}
		const resp = await this.Api.submitJob('POST', '/email_senders/start_verification', {
			email_addresses,
		});
		this.processing = true;
		resp.onJobComplete(() => {
			this.reload();
			this.processing = false;
		}, 1000);
		this.reload();
	}

	async resendVerificationEmail(record) {
		if (record.provider_status != 'failed' && record.provider_status != 'sharprAttemptFailed') {
			alert('You can only resend the verification email for users with a status of "failed" or "sharprAttemptFailed".');
			return;
		}
		await this.Api.post(`/email_senders/${record.id}/resend_verification`);
		this.reload();
	}

	reload() {
		this.$timeout(() => {
			this.filters.cb = (+new Date() - 1487628121261).toString(36);
		});
	}
}
